module.exports = __webpack_public_path__ + "static/img/summer_cheliziPic.4e0bad8a.png";